import { useState } from "react";
import { ListGroup, Spinner, Tab, Tabs } from "react-bootstrap";
import { Button } from "reactstrap";
import { useMutation, useQuery } from "@apollo/client";

import { simpleDate, simpleTime } from "../../../utils/displayDate";
import {
  APPROVE_TRANSACTION,
  CANCEL_TRANSACTION,
} from "../../../graphql/mutations/transaction";
import TransactionRecordTable from "../../transaction/components/TransactionRecordTable";
import { GET_TRANSACTION_RECORD } from "../../../graphql/queries/transaction";
import { TRANSACTION } from "../../../constants/transaction";
import { CancelIcon, CheckCircleIcon } from "../../../constants/icon_path";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../components/common/CustomErrorMessage";

const ApproveWithdraw = ({ data, handleClose, refetchRequestList }) => {
  const [key, setKey] = useState("detail");
  const { data: { transactionRecord } = {} } = useQuery(
    GET_TRANSACTION_RECORD,
    { variables: { member: data.member.id, action: TRANSACTION.WITHDRAW } }
  );
  const [approveTransaction, { loading }] = useMutation(APPROVE_TRANSACTION, {
    variables: { transactionId: data.id },
    onCompleted: (data) => {
      if (data.approveTransaction) {
        showSuccessToast();
        refetchRequestList();
        handleClose();
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });
  const [cancelTransaction, { loading: loadingCancel }] = useMutation(
    CANCEL_TRANSACTION,
    {
      variables: { transactionId: data.id },
      onCompleted: (data) => {
        if (data) {
          showSuccessToast();
          refetchRequestList();
          handleClose();
        }
      },
      onError(err) {
        showErrorToast(err.message);
      },
    }
  );

  const handleApprove = () => approveTransaction();
  const handleCancel = () => cancelTransaction();

  return (
    <div>
      <Tabs
        id="detail-tab"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3"
      >
        <Tab eventKey="detail" title="ລາຍລະອຽດ">
          <ListGroup>
            <ListGroup.Item>ເລກທີ່: {data?.transactionNo}</ListGroup.Item>
            <ListGroup.Item>
              ລະຫັດລູກຄ້າ: {data?.member?.memberId}
            </ListGroup.Item>
            <ListGroup.Item>ຊື່ລູກຄ້າ: {data?.member?.nickname}</ListGroup.Item>
            <ListGroup.Item>ຈຳນວນເຕີມ: {data?.amount}</ListGroup.Item>
            <ListGroup.Item>
              ວັນທີ່: {simpleDate(data?.createdAt)}{" "}
              {simpleTime(data?.createdAt)}
            </ListGroup.Item>
          </ListGroup>
          <div className="d-flex justify-content-evenly mt-2">
            <Button
              className="btn-sm"
              color="success"
              onClick={handleApprove}
              disabled={loading}
            >
              {loading && (
                <Spinner size="sm" variant="light" animation="border" />
              )}{" "}
              <CheckCircleIcon size={20} /> ຢືນຢັນການຖອນເງິນ
            </Button>
            <Button
              className="btn-sm"
              color="danger"
              onClick={handleCancel}
              disabled={loadingCancel}
            >
              {loadingCancel && (
                <Spinner size="sm" variant="light" animation="border" />
              )}{" "}
              <CancelIcon size={20} /> ຍົກເລີກການຖອນເງິນ
            </Button>
          </div>
        </Tab>
        <Tab eventKey="member" title="ປະຫວັດ ການເຕີມເງິນຂອງລູກຄ້າ">
          <TransactionRecordTable data={transactionRecord} />
        </Tab>
      </Tabs>
    </div>
  );
};

export default ApproveWithdraw;
